module.exports = __webpack_public_path__ + "img/dashboard-bg.e2f3ea75.jpg";